import { atom } from "recoil";

const orderErrorAtom = atom({
key: 'orderError',
default: {}
})

export {orderErrorAtom}